/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../styles/variables';
import AccessibleSVG, { SVGProps } from '../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const EmployeeReview56 = (props: SVGProps) => (
    <AccessibleSVG width={56} height={56} viewBox="0 0 56 56" {...props}>
        <g fill="none" fillRule="evenodd">
            <path
                fill={vars.bdlBoxBlue10}
                d="M8 31c2.21 0 4 1.79 4 4s-1.79 4-4 4-4-1.79-4-4 1.79-4 4-4zM44 8a8 8 0 110 16 8 8 0 010-16z"
            />
            <g transform="translate(8 6)">
                <path
                    fill={vars.bdlBoxBlue10}
                    fillRule="nonzero"
                    d="M27.001 2.562L27 7a3 3 0 002.824 2.995L30 10h5.226c-.196-.31-.426-.6-.689-.862l-.192-.182-6.303-5.672a4.97 4.97 0 00-1.041-.722z"
                />
                <path
                    fill={vars.white}
                    d="M25 2v5a5 5 0 005 5h6v11h1v13h-1v1a3 3 0 01-3 3H9a3 3 0 01-3-3V5a3 3 0 013-3h16z"
                />
                <path
                    fill={vars.bdlBoxBlue}
                    fillRule="nonzero"
                    d="M24.698 0c1.627 0 3.2.567 4.452 1.598l.23.199 6.303 5.672a6.998 6.998 0 012.311 4.92l.006.283V23a1 1 0 01-1.993.117L36 23V12.672c0-.226-.015-.45-.045-.672H30a4.999 4.999 0 01-4.995-4.783L25 7V2.01l-.038-.003L24.698 2H9a3 3 0 00-2.995 2.824L6 5v32a3 3 0 002.824 2.995L9 40h24a3 3 0 002.995-2.824L36 37v-1a1 1 0 011.993-.117L38 36v1a5.001 5.001 0 01-4.112 4.921l.028-.005a5.003 5.003 0 01-4.688 4.079L29 46H7a7 7 0 01-6.996-6.76L0 39V9a5.002 5.002 0 013.941-4.888l.143-.027-.011.063.012-.073A5.003 5.003 0 018.783.005L9 0h15.698zM3.999 6.17a3.004 3.004 0 00-1.993 2.636L2 9v30a4.999 4.999 0 004.783 4.995L7 44h22a3 3 0 002.829-2H9a4.999 4.999 0 01-4.995-4.783L4 37 3.999 6.17zM41.64 24.232c.392.326.47.889.203 1.307l-.075.101-5 6a1 1 0 01-1.382.15l-.093-.083-3-3a1 1 0 011.32-1.497l.094.083 2.225 2.224 4.3-5.157a1 1 0 011.408-.128zM27.001 2.562L27 7a3 3 0 002.824 2.995L30 10h5.226c-.196-.31-.426-.6-.689-.862l-.192-.182-6.303-5.672a4.97 4.97 0 00-1.041-.722z"
                />
                <path
                    fill={vars.bdlBoxBlue10}
                    fillRule="nonzero"
                    d="M4 6.17V37a5 5 0 005 5h22.83A3.003 3.003 0 0129 44H7a5 5 0 01-5-5V9c0-1.306.835-2.418 2-2.83z"
                />
                <rect width={8} height={1} x={10} y={6} fill={vars.bdlBoxBlue} rx={0.5} />
                <rect width={4} height={1} x={10} y={9} fill={vars.bdlBoxBlue} rx={0.5} />
                <path fill={vars.bdlBoxBlue10} fillRule="nonzero" d="M20.5 18a7.5 7.5 0 100 15 7.5 7.5 0 000-15z" />
                <path
                    fill={vars.bdlBoxBlue}
                    fillRule="nonzero"
                    d="M20.5 16c5.247 0 9.5 4.253 9.5 9.5S25.747 35 20.5 35 11 30.747 11 25.5s4.253-9.5 9.5-9.5zm0 2a7.5 7.5 0 00-5.25 12.856 5.503 5.503 0 0110.5-.001A7.5 7.5 0 0020.5 18zm0 3a2.5 2.5 0 010 5 2.5 2.5 0 010-5z"
                />
            </g>
        </g>
    </AccessibleSVG>
);

export default EmployeeReview56;
